module.exports = __webpack_public_path__ + "static/media/cross.fcecc4e9.svg";